export const actionPrefix = 'plecto/v3/trainingQuizzes/';
